/* CATEDO · fiche produit unifiée (13.09.2026). Aucun texte ici : tout vient des
   attributs posés par la section, donc de l'éditeur. */
(function () {
  var R = document.querySelector('[data-cf]');
  if (!R) return;
  var $ = function (s, el) { return (el || R).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || R).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var euro = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var go = function (el, off) { if (!el) return; var y = el.getBoundingClientRect().top + scrollY - (off || 90); scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); };

  /* ── galerie ── */
  var slides = $('[data-cf-slides]'), cpt = $('[data-cf-cpt]'), thumbs = $$('[data-cf-thumbs] .cf-th');
  var n = slides ? slides.children.length : 0, idx = 0;
  function marque(i) {
    idx = i;
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (cpt) cpt.textContent = (i + 1) + ' / ' + n;
    var t = thumbs[i], rail = t && t.parentElement;
    if (rail && rail.scrollWidth > rail.clientWidth) {
      var g = t.offsetLeft, d = g + t.offsetWidth;
      if (g < rail.scrollLeft) rail.scrollTo({ left: g - 10, behavior: 'smooth' });
      else if (d > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: d - rail.clientWidth + 10, behavior: 'smooth' });
    }
  }
  function montre(i) {
    if (!slides || !n) return;
    i = (i + n) % n;
    slides.scrollTo({ left: slides.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
    marque(i);
  }
  if (slides) {
    var att;
    slides.addEventListener('scroll', function () {
      clearTimeout(att);
      att = setTimeout(function () { var i = Math.round(slides.scrollLeft / slides.clientWidth); if (i !== idx) marque(i); }, 80);
    }, { passive: true });
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { montre(i); }); });
  $$('[data-cf-nav]').forEach(function (b) { b.addEventListener('click', function () { montre(idx + parseInt(b.dataset.cfNav, 10)); }); });

  /* ── variantes ── */
  var VAR = []; try { VAR = JSON.parse($('[data-cf-variants]').textContent); } catch (e) {}
  var champ = $('[data-cf-id]');
  var courant = VAR.filter(function (v) { return champ && String(v.id) === champ.value; })[0] || VAR[0];
  var choix = courant ? courant.options.slice() : [];
  var cta = $('[data-cf-cta]'), ctaTxt = $('[data-cf-ctatxt]'), ctaPrix = $('[data-cf-ctaprix]');
  var libCta = ctaTxt ? ctaTxt.textContent : '';
  var libRupture = ($('[data-cf-rupture]') || {}).textContent || '';
  $$('.cf-var').forEach(function (b) {
    b.addEventListener('click', function () {
      var pos = parseInt(b.dataset.cfPos, 10);
      choix[pos] = b.dataset.cfVal;
      var v = VAR.filter(function (x) { return x.options.every(function (o, j) { return o === choix[j]; }); })[0];
      $$('.cf-var[data-cf-pos="' + pos + '"]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var lib = $('[data-cf-optval="' + pos + '"]'); if (lib) lib.textContent = b.dataset.cfVal;
      if (b.dataset.cfMedia && slides) {
        var k = [].map.call(slides.children, function (s) { return s.dataset.mid; }).indexOf(b.dataset.cfMedia);
        if (k > -1) montre(k);
      }
      if (!v) { if (cta) cta.disabled = true; return; }
      courant = v;
      if (champ) champ.value = v.id;
      var p = euro(v.price);
      var px = $('[data-cf-prix]'); if (px) px.textContent = p;
      var br = $('[data-cf-barre]'); if (br) { br.hidden = !(v.compare_at_price > v.price); br.textContent = v.compare_at_price ? euro(v.compare_at_price) : ''; }
      var st = $('[data-cf-stock]'), ru = $('[data-cf-rupture]');
      if (st) st.hidden = !v.available; if (ru) ru.hidden = v.available;
      if (cta) { cta.disabled = !v.available; if (ctaTxt) ctaTxt.textContent = v.available ? libCta : libRupture; }
      lignesCadeau();
      var sv = $('[data-cf-stvar]'); if (sv) sv.textContent = v.title;
      if (v.featured_image && $('[data-cf-stimg]')) $('[data-cf-stimg]').src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    });
  });

  /* ── liens internes ── */
  var lire = $('[data-cf-lireplus]');
  if (lire) lire.addEventListener('click', function () {
    // 21.09 : la suite de la description est deja dans la page, rognee en hauteur. On l'ouvre sur place.
    var f = $('[data-cf-full]');
    if (f && !f.classList.contains('est-ouvert')) {
      f.classList.add('est-ouvert');
      var court = $('.cf-short');
      if (court) court.hidden = true;
      lire.setAttribute('aria-expanded', 'true');
      return;
    }
    var d = $('[data-cf-desc]'); if (!d) return;
    $$('[data-cf-bloc]').forEach(function (b) { b.open = true; });
    d.open = true; go(d, 100);
    if (!reduce) { d.classList.remove('flash'); void d.offsetWidth; d.classList.add('flash'); }
  });
  /* ── tuiles Caractéristiques (14.09) : une valeur qui ne tient pas à côté de son libellé passe
     dessous, alignée sur le texte du libellé, au lieu de tomber à droite ── */
  function pile() {
    $$('.cf-car-t').forEach(function (t) {
      var s = t.firstElementChild, b = t.querySelector(':scope > b');
      t.classList.remove('is-pile');
      if (s && b && b.offsetTop > s.offsetTop + 4) t.classList.add('is-pile');
    });
  }
  /* mesures insécables (14.09) : « 59 × 39 cm », « 232 à 284 cm » ne sont jamais coupés en fin de ligne */
  $$('.cf-pq__t,.cf-pq__b h3,.cf-pq__b p,.cf-pq__sig b,.cf-ben__t b').forEach(function (el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      n.nodeValue = n.nodeValue.replace(/(\d) (×|à|x) (?=\d)/g, '$1\u00a0$2\u00a0').replace(/(\d) (?=(cm|mm|m|kg|g|L|litres|dB|W|mAh|jours|h)\b)/g, '$1\u00a0');
    }
  });
  $$('details.cf-pq--car').forEach(function (d) { d.addEventListener('toggle', pile); });
  window.addEventListener('resize', pile);
  pile();
  $$('[data-cf-go]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var cible = a.dataset.cfGo === 'avis' ? $('[data-cf-avis]') : $('.cf-up');
      if (!cible) return; e.preventDefault(); go(cible, 90);
    });
  });

  /* ── livraison : même règle que la fiche V3 (bouclage, jours ouvrés) ── */
  var dl = $('[data-cf-dl]'), dateLiv = '';
  if (dl) {
    var MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    var JC = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    /* Autres langues : noms courts fournis par Intl selon la langue de la page (le français garde ses listes). */
    var LANG = (document.documentElement.lang || 'fr').toLowerCase();
    if (LANG.indexOf('fr') !== 0) {
      try {
        var fm = new Intl.DateTimeFormat(LANG, { month: 'short' }), fw = new Intl.DateTimeFormat(LANG, { weekday: 'short' });
        MOIS = []; JC = [];
        for (var im = 0; im < 12; im++) MOIS.push(fm.format(new Date(2023, im, 15)));
        for (var iw = 0; iw < 7; iw++) JC.push(fw.format(new Date(2023, 0, 1 + iw)));
      } catch (e) { /* liste française conservée */ }
    }
    var plus = function (d, k) { var x = new Date(d); x.setDate(x.getDate() + k); return x; };
    var ouvre = function (d) { var x = new Date(d); while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1); return x; };
    var jour0 = function (d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); };
    var cap = function (t) { return t.charAt(0).toUpperCase() + t.slice(1); };
    var peint = function () {
      var now = new Date(), h = parseInt(dl.dataset.heure, 10), mn = parseInt(dl.dataset.min, 10) || 2, mx = parseInt(dl.dataset.max, 10) || 6;
      /* 22.09 : envoi direct du fournisseur (data-direct) : les jours partent du jour de la commande, sans heure de bouclage. */
      var exp = dl.dataset.direct ? new Date(now) : ((now.getDay() === 0 || now.getDay() === 6) ? ouvre(now) : (now.getHours() >= h ? ouvre(plus(now, 1)) : new Date(now)));
      var d1 = ouvre(plus(exp, mn)), d2 = ouvre(plus(exp, mx));
      if (d2 < d1) d2 = d1;
      var ecart = Math.round((jour0(exp) - jour0(now)) / 86400000);
      var lexp = ecart === 0 ? dl.dataset.auj : (ecart === 1 ? dl.dataset.demain : cap(JC[exp.getDay()]) + ' ' + exp.getDate());
      var meme = d1.getMonth() === d2.getMonth();
      var t1 = JC[d1.getDay()] + ' ' + d1.getDate() + (meme ? '' : ' ' + MOIS[d1.getMonth()]);
      var t2 = JC[d2.getDay()] + ' ' + d2.getDate() + ' ' + MOIS[d2.getMonth()];
      var dd = $('[data-cf-dldate]');
      if (dd) dd.innerHTML = esc(dd.dataset.modele).replace('#D1#', '<strong>' + esc(t1) + '</strong>').replace('#D2#', '<strong>' + esc(t2) + '</strong>');
      var be = $('[data-cf-dlexp]'); if (be) be.textContent = lexp;
      var bl = $('[data-cf-dlliv]'); if (bl) bl.textContent = d1.getDate() + (meme ? '' : ' ' + MOIS[d1.getMonth()]) + ' ' + ((window.CatedoStrings && window.CatedoStrings.dateTo) || 'au') + ' ' + d2.getDate() + ' ' + MOIS[d2.getMonth()];
      dateLiv = dd ? dd.textContent : '';
      var sl = $('[data-cf-stliv]'); if (sl && dateLiv) sl.textContent = ' · ' + dateLiv.charAt(0).toLowerCase() + dateLiv.slice(1);
    };
    peint(); setInterval(peint, 60000);
    if ('IntersectionObserver' in window && !reduce) {
      new IntersectionObserver(function (e) { if (e[0].isIntersecting) { dl.classList.remove('play'); void dl.offsetWidth; dl.classList.add('play'); } }, { threshold: .6 }).observe(dl);
    }
  }

  /* ── panier du thème ── */
  var tiroir = function () { return document.querySelector('cart-drawer'); };
  function sectionsPanier() {
    var t = tiroir();
    var ids = t && t.getSectionsToRender ? t.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-icon-bubble'];
    if (ids.indexOf('cart-icon-bubble') < 0) ids.push('cart-icon-bubble');
    return ids;
  }
  function rafraichit(d, ouvrir) {
    var t = tiroir();
    if (t && t.renderContents && ouvrir) { t.renderContents(d); }
    else if (d.sections) {
      if (t && t.getSectionsToRender) {
        t.getSectionsToRender().forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (el && d.sections[s.id]) el.innerHTML = t.getSectionInnerHTML(d.sections[s.id], s.selector);
        });
      }
      var bub = document.getElementById('cart-icon-bubble');
      if (bub && d.sections['cart-icon-bubble']) {
        var sec = new DOMParser().parseFromString(d.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (sec) bub.innerHTML = sec.innerHTML;
      }
    }
    try {
      if (t && d.sections && d.sections['cart-drawer']) {
        var neuf = new DOMParser().parseFromString(d.sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
        if (neuf) t.classList.toggle('is-empty', neuf.classList.contains('is-empty'));
      }
    } catch (e) {}
  }
  function poste(url, corps) {
    corps.sections = sectionsPanier().join(',');
    corps.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(corps) })
      .then(function (r) { return r.json(); });
  }
  var root = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url.replace(/cart\/add$/, '') : '/';

  var form = $('[data-cf-form]');
  /* Un seul envoi : le produit ET les accessoires sélectionnés. Le tiroir s'ouvre une fois. */
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (cta.disabled || cta.getAttribute('aria-busy') === 'true') return;
    cta.setAttribute('aria-busy', 'true');
    var items = [{ id: champ.value, quantity: 1 }];
    selection().forEach(function (r) { items.push({ id: r.dataset.cfAcc, quantity: 1 }); });
    var avecCadeau = totalCadeau() >= montant && items.length >= 2 && !!$('[data-cf-gf]');
    poste(root + 'cart/add.js', { items: items })
      .then(function (d) {
        if (d.status) { location.href = root + 'cart'; return; }
        if (tiroir()) rafraichit(d, true); else { location.href = root + 'cart'; return; }
        etat = {}; lignesCadeau();
        var dn = $('[data-cf-done]'), dt = $('[data-cf-donetxt]');
        /* message sous la liste retiré : le tiroir s'ouvre avec « Félicitations ! Choisissez votre cadeau offert » */
      })
      .catch(function () { form.submit(); })
      .then(function () { cta.removeAttribute('aria-busy'); });
  });

  /* ── complétez son installation + cadeau (dès un montant de panier, 14.09) ── */
  var rows = $$('[data-cf-acc]');
  var montant = parseInt(R.dataset.montant, 10) || 10000;
  var cadeaux = (R.dataset.cadeaux || '').split(',').filter(Boolean), estCadeau = R.dataset.estCadeau === '1';
  var etat = {};   /* 16.09 : la fiche ne compte que ce qui est sur la page (fiche + accessoires cochés), jamais le panier */
  function selection() { return (rows || []).filter(function (r) { return etat[r.dataset.cfAcc]; }); }
  function totalCadeau() {
    /* les 3 cadeaux ne comptent pas, comme dans la remise Shopify */
    var t = courant && !estCadeau ? courant.price : 0;
    selection().forEach(function (r) { if (r.dataset.cfCadeau !== '1') t += parseInt(r.dataset.cfAccprix, 10) || 0; });
    return t;
  }
  /* 100,00 € s'écrit 100 € */
  var euroCourt = function (c) { return euro(c).replace(',00', ''); };
  /* total du bouton principal et de la barre collante : produit + accessoires sélectionnés */
  function majTotal() {
    var base = courant ? courant.price : 0, sel = rows ? selection() : [], tot = base;
    sel.forEach(function (r) { tot += parseInt(r.dataset.cfAccprix, 10) || 0; });
    var n = sel.length + 1, lib = R.dataset.articles || '#N# articles';
    var suffixe = sel.length ? lib.replace('#N#', n) + ' · ' : '';
    if (ctaPrix) ctaPrix.textContent = suffixe + euro(tot);
    var sp = $('[data-cf-stprix]'); if (sp) sp.textContent = euro(tot);
    var sn = $('[data-cf-stnb]'); if (sn) { sn.textContent = sel.length ? lib.replace('#N#', n) : ''; sn.hidden = !sel.length; }
  }
  /* Offre (14.09) : 2 articles minimum ET montant minimum, les cadeaux ne comptent pas.
     Pas de « Félicitations » sur la fiche : le panier félicite au moment où l'offre est remplie. */
  function etatOffre() {
    var sel = selection().filter(function (r) { return r.dataset.cfCadeau !== '1'; }).length;
    var base = courant && !estCadeau ? courant.price : 0;
    var nArt = (estCadeau ? 0 : 1) + sel, tot = totalCadeau();
    return { tot: tot, nArt: nArt, grand: base >= montant, ok: tot >= montant && nArt >= 2 };
  }
  function lignesCadeau() {
    var o = etatOffre();
    rows.forEach(function (r) {
      var on = !!etat[r.dataset.cfAcc];
      r.classList.toggle('in', on);
      var b = $('[data-cf-add]', r); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var gf = $('[data-cf-gf]');
    if (gf) {
      gf.classList.toggle('ok', o.ok);
      var j = $('[data-cf-jauge]', gf), gn = $('[data-cf-gfn]'), gt = $('[data-cf-gft]');
      if (j) j.style.width = (o.ok ? 100 : Math.min(100, o.nArt / 2 * 100)) + '%';
      if (gn) gn.textContent = gn.dataset.motArt.replace('#A#', Math.min(o.nArt, 2));
      if (gt) {
        gt.querySelector('b').textContent = o.ok ? gt.dataset.okT : (o.grand ? gt.dataset.grandT : gt.dataset.petitT.replace('#S#', euroCourt(montant)));
        gt.querySelector('span').textContent = o.ok ? gt.dataset.okS : (o.grand ? gt.dataset.grandS : gt.dataset.petitS);
      }
    }
    var dn = $('[data-cf-done]'); if (dn) dn.classList.remove('on');
    var of = $('[data-cf-offretxt]'), ofp = $('[data-cf-offre]');
    if (of && ofp) { ofp.classList.toggle('is-ok', o.ok); of.textContent = o.ok ? ofp.dataset.ok : (o.grand ? ofp.dataset.grand : ofp.dataset.petit); }
    majTotal();
    if (qvRow) etatApercu();
  }
  /* « Ajouter » sélectionne l'accessoire : rien ne part au panier avant le bouton principal */
  function bascule(row) {
    var id = row.dataset.cfAcc;
    etat[id] = !etat[id];
    lignesCadeau();
  }
  rows.forEach(function (r) {
    var b = $('[data-cf-add]', r);
    if (b) b.addEventListener('click', function () { bascule(r); });
    $$('[data-cf-qv]', r).forEach(function (x) { x.addEventListener('click', function () { ouvreApercu(r, x); }); });
  });
  lignesCadeau();

  /* ── aperçu d'un produit ── */
  var ov = $('[data-cf-ov]'), qvRow = null, qvFrom = null;
  var etoile = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.6 5.6 6 .7-4.5 4.1 1.2 6L12 16.4 6.7 19.4l1.2-6L3.4 9.3l6-.7z"/></svg>';
  var coche = '<svg class="cf-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  function donnees(r) { try { return JSON.parse($('[data-cf-qvdata]', r).textContent); } catch (e) { return null; } }
  function etatApercu() {
    var d = donnees(qvRow), on = !!etat[qvRow.dataset.cfAcc], b = $('[data-cf-qvadd]');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.innerHTML = on ? coche + esc(b.dataset.ajoute) : esc(b.dataset.ajouter) + ' <span class="cf-sep">·</span> <span class="cf-num">' + esc(d.prix) + '</span>';
    var g = $('[data-cf-qvg]'), gt = $('[data-cf-qvgt]');
    if (g && gt) {
      var ok = etatOffre().ok;
      g.classList.toggle('ok', ok); gt.innerHTML = ok ? gt.dataset.apres : gt.dataset.avant;
    }
  }
  function ouvreApercu(r, from) {
    var d = donnees(r); if (!d || !ov) return;
    qvRow = r; qvFrom = from;
    $('[data-cf-qvt]').textContent = d.t;
    var rr = $('[data-cf-qvr]'); rr.style.display = d.note ? 'flex' : 'none';
    rr.innerHTML = d.note ? etoile + etoile + etoile + etoile + etoile + '<b>' + esc(d.note) + '</b>(' + esc(d.nb) + ')' : '';
    $('[data-cf-qvp]').innerHTML = '<strong>' + esc(d.prix) + '</strong>' + (d.barre ? '<s>' + esc(d.barre) + '</s><em>' + esc(d.eco) + '</em>' : '');
    var l = $('[data-cf-qvl]'); l.innerHTML = (d.b || []).map(function (x) { return '<li>' + coche + esc(x) + '</li>'; }).join(''); l.hidden = !(d.b && d.b.length);
    var im = $('[data-cf-qvimg]'), th = $('[data-cf-qvth]');
    im.src = d.img[0] || ''; im.alt = d.t;
    th.innerHTML = d.img.length > 1 ? d.img.map(function (u, j) { return '<button type="button" data-u="' + esc(u) + '" aria-current="' + (j === 0) + '"><img alt="" src="' + esc(u) + '"></button>'; }).join('') : '';
    $('[data-cf-qvf]').href = d.url;
    etatApercu();
    ov.classList.add('on'); ov.setAttribute('aria-hidden', 'false');
    setTimeout(function () { $('[data-cf-qvx]').focus(); }, 60);
  }
  function fermeApercu() { if (!ov || !ov.classList.contains('on')) return; ov.classList.remove('on'); ov.setAttribute('aria-hidden', 'true'); qvRow = null; if (qvFrom) qvFrom.focus({ preventScroll: true }); }
  if (ov) {
    $('[data-cf-qvx]').addEventListener('click', fermeApercu);
    ov.addEventListener('click', function (e) { if (e.target === ov) fermeApercu(); });
    $('[data-cf-qvth]').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      $('[data-cf-qvimg]').src = b.dataset.u;
      $$('button', $('[data-cf-qvth]')).forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
    $('[data-cf-qvadd]').addEventListener('click', function () { if (qvRow) bascule(qvRow); });
  }

  /* ── vous aimerez aussi : ajout en un clic ── */
  $$('[data-cf-rcadd]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var lib = b.textContent;
      poste(root + 'cart/add.js', { items: [{ id: b.dataset.cfRcadd, quantity: 1 }] }).then(function (d) {
        if (d.status) return;
        rafraichit(d, false);
        b.classList.add('ok'); b.textContent = b.dataset.ok;
        setTimeout(function () { b.classList.remove('ok'); b.textContent = lib; }, 1800);
      }).catch(function () {});
    });
  });

  /* ── barre collante ── */
  var sticky = $('[data-cf-sticky]');
  if (sticky && cta && 'IntersectionObserver' in window) {
    var ctaVu = true, piedVu = false;
    /* Règle : la barre apparaît quand le bouton d'achat est sorti par le haut.
       Sur ordinateur, réglage « après la colonne d'achat » : elle attend en plus
       que la colonne (et donc « Complétez son installation ») soit passée, pour
       ne jamais recouvrir les boutons Ajouter des accessoires. */
    var apresCol = sticky.dataset.regle === 'colonne', info = $('.cf-info');
    var maj = function () {
      var on = !ctaVu && !piedVu && cta.getBoundingClientRect().top < 0;
      if (on && apresCol && innerWidth > 749 && info) on = info.getBoundingClientRect().bottom < innerHeight - 90;
      sticky.classList.toggle('on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      $('[data-cf-stcta]').tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (e) { ctaVu = e[0].isIntersecting; maj(); }).observe(cta);
    var pied = document.querySelector('footer, .footer');
    if (pied) new IntersectionObserver(function (e) { piedVu = e[0].isIntersecting; maj(); }).observe(pied);
    addEventListener('scroll', function () { if (!ctaVu) maj(); }, { passive: true });
    addEventListener('resize', maj);
    $('[data-cf-stcta]').addEventListener('click', function () { if (!cta.disabled) form.requestSubmit ? form.requestSubmit() : cta.click(); });
  }

  /* ── avis : les 29 viennent de l'API publique de Judge.me ── */
  /* 16.09 : « Écrire un avis » ouvre la fenêtre officielle de Judge.me.
     Le widget est livré dans un <template> : rien de Judge.me ne se charge à l'arrivée sur la fiche.
     Il se charge en arrière-plan quand le client approche des avis ou touche le bouton, donc la fenêtre est prête au clic. */
  var jdgm = $('[data-cf-jdgm]');
  if (jdgm) {
    var jmParti = false;
    var chargerJm = function () {
      if (jmParti) return;
      jmParti = true;
      var tpl = jdgm.querySelector('template[data-cf-jdgmtpl]');
      if (!tpl) return;
      jdgm.appendChild(document.importNode(tpl.content, true));
      tpl.remove();
      var src = '';
      document.querySelectorAll('script[src*="loader.js"]').forEach(function (s) { if (/judgeme/.test(s.src)) src = s.src; });
      if (window.jdgm && src) {
        window.jdgm._loaderExecuted = false;
        var s = document.createElement('script');
        s.src = src; s.async = true;
        document.head.appendChild(s);
      }
    };
    var bientot = function () { if (document.readyState === 'complete') chargerJm(); else addEventListener('load', chargerJm); };
    var zone = $('[data-cf-avis]') || jdgm;
    if ('IntersectionObserver' in window) {
      var ioJm = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { ioJm.disconnect(); bientot(); } }, { rootMargin: '800px 0px' });
      ioJm.observe(zone);
    }
    document.querySelectorAll('[data-cf-avform]').forEach(function (b) {
      ['pointerenter', 'touchstart', 'focus'].forEach(function (t) { b.addEventListener(t, chargerJm, { passive: true, once: true }); });
      b.addEventListener('click', function () {
        chargerJm();
        /* la fenêtre est posée dans <body>, hors de la section : on lui passe les couleurs, l'arrondi et les polices réglés dans l'éditeur */
        var cf = jdgm.closest('.cf');
        if (cf && !document.body.style.getPropertyValue('--cf-encre')) { var c = getComputedStyle(cf); ['encre', 'corps', 'doux', 'trait', 'trait2', 'sable', 'or', 'orclair', 'rouge', 'rougev', 'r', 'd', 't'].forEach(function (k) { document.body.style.setProperty('--cf-' + k, c.getPropertyValue('--cf-' + k)); }); }
        if (b.getAttribute('aria-busy')) return;
        var txt = b.textContent, n = 0;
        var fin = function () { b.textContent = txt; b.removeAttribute('aria-busy'); };
        var essai = function () {
          var m = document.querySelector('.jdgm-write-review-modal__content');
          if (m && m.offsetHeight) return fin();
          var bt = jdgm.querySelector('.jm-action-buttons__button, .jdgm-write-rev-link');
          if (bt && n % 5 === 0) bt.click();
          if (++n === 3 && b.dataset.attente) { b.textContent = b.dataset.attente; b.setAttribute('aria-busy', 'true'); }
          if (n < 100) setTimeout(essai, 150); else fin();
        };
        essai();
      });
    });
  }
  var av = $('[data-cf-avis]');
  if (av) {
    var grid = $('[data-cf-avgrid]', av), pag = $('[data-cf-avpag]', av), fil = $('[data-cf-avfil]', av);
    var modal = $('[data-cf-avm]'), modalC = $('[data-cf-avmc]');
    var PP = parseInt(av.dataset.pp, 10) || 6, TOUS = [], note = 0, page = 1;
    var jm = '<span class="cf-avc__jm" title="' + esc(av.dataset.jmt) + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="11"></circle><path d="M7 12.4l3.3 3.3L17.2 8.8"></path></svg></span>';
    var date = function (s) { var d = new Date(s); if (isNaN(d)) return ''; return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear(); };
    var etoiles = function (k) { var s = ''; for (var i = 1; i <= 5; i++) s += i <= k ? '★' : '<span class="off">★</span>'; return s; };
    var texte = function (h) { var t = document.createElement('div'); t.innerHTML = h || ''; return (t.textContent || '').replace(/\s+/g, ' ').trim(); };
    var liste = function () { return TOUS.filter(function (r) { return !note || r.n === note; }); };
    var tete = function (r) { return '<div class="cf-avc__h"><span class="cf-avc__a">' + esc(r.nom.charAt(0).toUpperCase()) + '</span><span class="cf-avc__n">' + esc(r.nom) + '</span><span class="cf-avc__m">' + jm + '<span class="cf-avc__d">' + esc(r.d) + '</span></span></div><span class="cf-avc__s" aria-hidden="true">' + etoiles(r.n) + '</span>'; };
    var carte = function (r, k) {
      return '<article class="cf-avc">' + tete(r) +
        (r.t ? '<p class="cf-avc__t" data-k="' + k + '">' + esc(r.t) + '</p>' : '<p class="cf-avc__t vide">' + esc(av.dataset.vide) + '</p>') +
        '<a class="cf-avc__p" href="#" data-cf-top><img src="' + esc(av.dataset.pimg) + '" alt="" width="30" height="30" loading="lazy"><span><b>' + esc(av.dataset.pnom) + '</b>' + esc(av.dataset.pvoir) + '</span><em aria-hidden="true">→</em></a></article>';
    };
    var coupe = function (p) {
      var full = p.textContent, max = Math.round(parseFloat(getComputedStyle(p).lineHeight) * 3) + 1;
      if (p.clientHeight - 10 <= max) return;
      var btn = ' <button type="button" class="cf-avc__plus" data-k="' + p.dataset.k + '">' + esc(av.dataset.plus) + '</button>', lo = 0, hi = full.length, best = 0;
      while (lo <= hi) { var mid = (lo + hi) >> 1; p.innerHTML = esc(full.slice(0, mid).replace(/\s+\S*$/, '')) + '…' + btn; if (p.clientHeight - 10 <= max) { best = mid; lo = mid + 1; } else hi = mid - 1; }
      p.innerHTML = esc(full.slice(0, best).replace(/\s+\S*$/, '')) + '…' + btn;
    };
    var fleche = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>'; };
    var rendre = function (anim) {
      var L = liste(), np = Math.max(1, Math.ceil(L.length / PP)); if (page > np) page = np;
      var d = (page - 1) * PP, P = L.slice(d, d + PP);
      grid.classList.toggle('is-anim', !!anim);
      grid.innerHTML = P.map(function (r, j) { return carte(r, d + j); }).join('');
      $$('.cf-avc__t[data-k]', grid).forEach(coupe);
      var h = '';
      if (np > 1) {
        h += '<button type="button" data-p="' + (page - 1) + '" aria-label="' + esc(av.dataset.prec) + '"' + (page === 1 ? ' disabled' : '') + '>' + fleche(-1) + '</button>';
        for (var i = 1; i <= np; i++) h += '<button type="button" data-p="' + i + '"' + (i === page ? ' aria-current="page"' : '') + ' aria-label="' + esc(av.dataset.page) + ' ' + i + '">' + i + '</button>';
        h += '<button type="button" data-p="' + (page + 1) + '" aria-label="' + esc(av.dataset.suiv) + '"' + (page === np ? ' disabled' : '') + '>' + fleche(1) + '</button>';
      }
      pag.innerHTML = h;
    };
    pag.addEventListener('click', function (e) { var b = e.target.closest('[data-p]'); if (!b || b.disabled) return; page = +b.dataset.p; rendre(true); go(av, 80); });
    fil.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !TOUS.length) return;
      note = +b.dataset.r; page = 1;
      $$('button', fil).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      rendre(true);
    });
    grid.addEventListener('click', function (e) {
      if (e.target.closest('[data-cf-top]')) { e.preventDefault(); scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
      var b = e.target.closest('.cf-avc__plus'); if (!b) return;
      var r = liste()[+b.dataset.k]; if (!r || !modal) return;
      modalC.innerHTML = tete(r) + '<p class="cf-avc__t">' + esc(r.t) + '</p>';
      modal.classList.add('on'); modal.setAttribute('aria-hidden', 'false');
      $('[data-cf-avmx]').focus({ preventScroll: true });
      modal._from = b;
    });
    var fermeAvis = function () { if (!modal || !modal.classList.contains('on')) return; modal.classList.remove('on'); modal.setAttribute('aria-hidden', 'true'); if (modal._from) modal._from.focus({ preventScroll: true }); };
    if (modal) { $('[data-cf-avmx]').addEventListener('click', fermeAvis); modal.addEventListener('click', function (e) { if (e.target === modal) fermeAvis(); }); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { fermeAvis(); fermeApercu(); } });

    var charge = function () {
      var base = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(av.dataset.shop) + '&shop_domain=' + encodeURIComponent(av.dataset.shop) + '&platform=shopify&per_page=30&product_id=' + encodeURIComponent(av.dataset.pid);
      var tout = [];
      var suivante = function (p) {
        return fetch(base + '&page=' + p).then(function (r) { return r.json(); }).then(function (j) {
          (j.reviews || []).forEach(function (r) {
            var t = texte(r.body_html);
            if (r.product_title && t === r.product_title) t = '';
            tout.push({ nom: r.reviewer_name || '', n: parseInt(r.rating, 10) || 0, d: date(r.created_at), t: t });
          });
          var tp = j.pagination ? j.pagination.total_pages : 1;
          if (p < tp && p < 20) return suivante(p + 1);
        });
      };
      suivante(1).then(function () { if (tout.length) { TOUS = tout; rendre(false); } }).catch(function () {});
    };
    /* 16.09 : Judge.me met ~2 s à répondre. On demande la liste au premier de ces deux moments :
       la fiche a fini de charger, ou le client approche des avis (6,6 Ko, gardés 20 min par le navigateur). */
    var avisParti = false, go1 = function () { if (!avisParti) { avisParti = true; charge(); } };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); go1(); } }, { rootMargin: '1500px 0px' });
      io.observe(av);
    }
    var lanceAvis = function () { if ('requestIdleCallback' in window) requestIdleCallback(go1, { timeout: 1500 }); else setTimeout(go1, 200); };
    if (document.readyState === 'complete') lanceAvis(); else addEventListener('load', lanceAvis, { once: true });
  }
})();
